import { Button, Container, FormControl, Grid, InputLabel, Select, TextField, MenuItem } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import BackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import * as queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";
import {
    getEquipmentTypeList,
    getEqMainList,
    getCostCenterList,
    getPlantList,
    getAreaList,
    getAddEquipment,
    getEditEquipment,
    resetEqGroup,
    getEquipmentDetailById,
    resetEqMainList,
} from "../../store/actions/EquipmentAction";

const initialRow = {
    code: "",
    name: "",
    barcodeContent: "",
};

export default function EditEquipment() {
    const [row, setRow] = useState(initialRow);
    const dispatch = useDispatch();
    const [pageLoaded, setPageLoaded] = useState(false);
    const [readOnlyArea, setReadOnlyArea] = useState(true);
    const { t } = useTranslation("translation");

    useEffect(() => {
        GetAreaCodeHandler();
        GetCostCenterHandler();
        GetPlantCodeHandler();
        GetEquipmentTypeCodeHandler();
        GetMainEquipmentHandler();
        if (queryString.parse(window.location.search).id != 0) {
            LoadHandler();
        } else {
            setReadOnlyArea(false);
            setPageLoaded(true);
        }
    }, []);

    const { costCenters, plants, areas, eqTypes, equipmentAgainstId, eqMainList, eqRes } = useSelector(({ equipment }) => equipment);

    useEffect(() => {
        if (costCenters?.resultObject) {
            setCostCenterList(costCenters.resultObject);
        }else{
            setCostCenterList([]);
        }
    }, [costCenters]);

    useEffect(() => {
        if (areas?.resultObject) {
            setAreaList(areas.resultObject);
        }else{
            setAreaList([]);
        }
    }, [areas]);

    useEffect(() => {
        if (plants?.resultObject) {
            setPlantList(plants.resultObject);
        }else{
            setPlantList([]);
        }
    }, [plants]);

    useEffect(() => {
        if (eqTypes?.resultObject) {
            setEquipmentTypeList(eqTypes.resultObject);
        }else{
            setEquipmentTypeList([]);
        }
    }, [eqTypes]);

    useEffect(() => {
        if (eqMainList?.resultObject) {
            setMainEquipmentList(eqMainList.resultObject);
            dispatch(resetEqMainList());
        }
    }, [eqMainList]);

    useEffect(() => {
        if (equipmentAgainstId?.resultObject) {
            setAddedMainEquipmentID(equipmentAgainstId.resultObject.mainEquipmentId);
            setRow(equipmentAgainstId.resultObject);
            setAddedAreaID(equipmentAgainstId.resultObject.areaCode != null ? NewAreaID(equipmentAgainstId.resultObject.areaCode) : 0);
            setAddedEquipmentTypeID(equipmentAgainstId.resultObject.typeCode != null ? NewEquipmentTypeID(equipmentAgainstId.resultObject.typeCode) : 0)
            setAddedCostCenterID(equipmentAgainstId.resultObject.costCenterCode != null ? NewCostCenterID(equipmentAgainstId.resultObject.costCenterCode) : 0)
            setPageLoaded(true);
            dispatch(resetEqGroup());
        }
    }, [equipmentAgainstId]);

    useEffect(() => {
        if (eqRes?.data) {
            TurnBack();
        }
    }, [eqRes]);

    const LoadHandler = () => {
        let payload = {
            id: queryString.parse(window.location.search).id,
            editEqRequest: true,
        };
        dispatch(getEquipmentDetailById(payload));
    };

    //get plant codes
    const [plantList, setPlantList] = useState([]);
    const GetPlantCodeHandler = () => {
        dispatch(getPlantList());
    };

    //get equipment type codes
    const [equipmentTypeList, setEquipmentTypeList] = useState([]);
    const GetEquipmentTypeCodeHandler = () => {
        dispatch(getEquipmentTypeList());
    };

    //get area codes
    const [areaList, setAreaList] = useState([]);
    const GetAreaCodeHandler = () => {
        dispatch(getAreaList());
    };

    //get cost center codes
    const [costCenterList, setCostCenterList] = useState([]);
    const GetCostCenterHandler = () => {
        dispatch(getCostCenterList());
    };

    //get main equipment codes
    const [mainEquipmentList, setMainEquipmentList] = useState([]);
    const GetMainEquipmentHandler = () => {
        let payload = {
            isMain: true,
        };
        dispatch(getEqMainList(payload));
    };

    //set plantID
    let [addPlantID, setAddedPlantID] = useState(0);
    const NewPlantID = (plantCode) => {
        if (plantCode != null) {
            const filteredPlant = plantList.filter((item) => item.code.includes(plantCode));
            setAddedPlantID(filteredPlant[0].id);
            return filteredPlant[0].id;
        }
    };

    //set equipmentTypeID
    let [addEquipmentTypeID, setAddedEquipmentTypeID] = useState(0);
    const NewEquipmentTypeID = (equipmentTypeCode) => {
        if (equipmentTypeCode != null) {
            const filteredEquipmentType = equipmentTypeList.filter((item) => item.code.includes(equipmentTypeCode));
            setAddedEquipmentTypeID(filteredEquipmentType[0].id);
            return filteredEquipmentType[0].id;
        }
        setAddedEquipmentTypeID(0);
    };

    //set AreaID
    let [addAreaID, setAddedAreaID] = useState(0);
    const NewAreaID = (areaCode) => {
        if (areaCode != null) {
            const filteredArea = areaList.filter((item) => item.code.includes(areaCode));
            setAddedAreaID(filteredArea[0].id);
            return filteredArea[0].id;
        }
        setAddedAreaID(0);
    };

    //set costCenterID
    let [addcostCenterID, setAddedCostCenterID] = useState(0);
    const NewCostCenterID = (costCenterCode) => {
        if (costCenterCode != null) {
            const filteredCostCenter = costCenterList.filter((item) => item.code.includes(costCenterCode));
            setAddedCostCenterID(filteredCostCenter[0].id);
            return filteredCostCenter[0].id;
        } else {
            setAddedCostCenterID(0);
        }
    };

    //set mainEquipmentID
    let [addMainEquipmentID, setAddedMainEquipmentID] = useState(0);
    const NewMainEquipmentID = (mainEquipmentCode) => {
        if (mainEquipmentCode != null) {
            if (isNaN(mainEquipmentCode)) {
                const filteredMainEquipment = mainEquipmentList.filter((item) => item.code == mainEquipmentCode);
                setAddedMainEquipmentID(filteredMainEquipment[0].id);
                return filteredMainEquipment[0].id;
            }
            return 0;
        }
        setAddedMainEquipmentID(null);
        return null;
    };

    const history = useHistory();
    const TurnBack = () => {
        history.push({ pathname: "/equipment/" });
    };

    //set edited rows
    function SetRowHandler(value, obj, updatedRow) {
        const index = row.indexOf(updatedRow);
        if (updatedRow.id != "") {
            const data = row[index];
            data[obj] = value;
            row[index] = data;
            setRow(row);
        } else {
            const data = row[index];
            data[obj] = value;
            setRow(row);
        }
    }

    function SetRowHandler(value, obj) {
        setRow({ ...row, [obj]: value });
    }

    //main equipment can be null
    const SetMainEquipment = (row) => {
        if (row.mainEquipment === null || row.mainEquipment === undefined) {
            return null;
        } else {
            return row.mainEquipment.code;
        }
    };

    //update and add in one function
    const UpdateAddHandler = (row) => {
        //update equipment
        if (row.id != undefined) {
            const data = {
                id: row.id,
                code: row.code,
                name: row.name,
                sapCode: row.sapCode,
                barcodeContent: row.barcodeContent,
                brand: row.brand,
                model: row.model,
                warrantyStart: row.warrantyStart,
                warrantyEnd: row.warrantyEnd,
                priority: row.priority,
                status: row.status,
                mainEquipmentId: addMainEquipmentID == 0 ? NewMainEquipmentID(addMainEquipmentID) : addMainEquipmentID,
                typeId: addEquipmentTypeID == 0 ? NewEquipmentTypeID(row.typeCode) : addEquipmentTypeID,
                plantId: row.plantId,
                areaId: addAreaID == 0 ? NewAreaID(row.areaCode) : addAreaID,
                costCenterId: addcostCenterID == 0 ? NewCostCenterID(row.costCenterCode) : addcostCenterID,
                mesCode: row.mesCode,
                freeText1: row.freeText1,
                freeText2: row.freeText2,
                freeText3: row.freeText3,
                freeText4: row.freeText4,
            };

            dispatch(getEditEquipment(data));
        }
        //add equipment
        else {
            const data = {
                code: row.code,
                name: row.name,
                sapCode: row.sapCode,
                barcodeContent: row.barcodeContent,
                brand: row.brand,
                model: row.model,
                warrantyStart: row.warrantyStart,
                warrantyEnd: row.warrantyEnd,
                priority: row.priority,
                mainEquipmentId: addMainEquipmentID,
                typeId: addEquipmentTypeID,
                plantId: plantList[0].id,
                areaId: addAreaID,
                costCenterId: addcostCenterID,
                mesCode: row.mesCode,
                freeText1: row.freeText1,
                freeText2: row.freeText2,
                freeText3: row.freeText3,
                freeText4: row.freeText4,
            };
            dispatch(getAddEquipment(data));
        }
    };

    // Validation
    const [error, setError] = useState({
        equipmentCodeText: t("EnterAnEquipmentCode"),
        equipmentNameText: t("EnterAnEquipmentName"),
        costCenterText: t("EnterACostCenter"),
        equipmentTypeText: t("EnterAnEquipmentType"),
        areaGroupText: t("SelectAnAreaGroup"),
        barcodeContentText: t("EnterABarcodeContent"),
    });
    const [isButtonDisable, setIsButtonDisable] = useState(true);

    useEffect(() => {
        const newEquipmentCodeText = row.code !== "" ? "" : t("EnterAnEquipmentCode");
        const newEquipmentNameText = row.name !== "" ? "" : t("EnterAnEquipmentName");
        const newEquipmentTypeText = addEquipmentTypeID !== 0 ? "" : t("EnterAnEquipmentType");
        const newCostCenterText = addcostCenterID !== 0 ? "" : t("EnterACostCenter");
        const newAreaGroupText = addAreaID !== 0 ? "" : t("SelectAnAreaGroup");
        const newBarcodeContentText = row.barcodeContent !== "" ? "" : t("EnterABarcodeContent");
        setError({
            equipmentCodeText: newEquipmentCodeText,
            equipmentNameText: newEquipmentNameText,
            equipmentTypeText: newEquipmentTypeText,
            costCenterText: newCostCenterText,
            areaGroupText: newAreaGroupText,
            barcodeContentText: newBarcodeContentText,
        });
    }, [row, addAreaID, addEquipmentTypeID, addcostCenterID]);

    useEffect(() => {
        if (error.equipmentCodeText === "" && error.equipmentNameText === "" && error.equipmentTypeText === "" && error.costCenterText === "" && error.areaGroupText === "" && error.barcodeContentText === "") {
            setIsButtonDisable(false);
        } else {
            setIsButtonDisable(true);
        }
    }, [error]);

    return (
        <Container maxWidth="xs">
            <h1>{t("EquipmentInformation")}</h1>
            {pageLoaded === true ? (
                <Grid container spacing={3} style={{ marginBottom: 30 }}>
                    <Autocomplete id="eq_MainEquipment"
                        defaultValue={row != null ? SetMainEquipment(row) : ""}
                        onChange={(event, newValue) => {
                            NewMainEquipmentID(newValue);
                        }}
                        options={mainEquipmentList.map((option) => option.code)}
                        renderInput={(params) => <TextField {...params} margin="normal" label={t("MainEquipment")} variant="outlined" />}
                        fullWidth
                    />
                    <TextField id="eq_EquipmentCode"
                        label={t("EquipmentCode")}
                        onInput={(e) => SetRowHandler(e.target.value, "code", row)}
                        defaultValue={row != null ? row.code : ""}
                        variant="outlined"
                        InputProps={{ readOnly: readOnlyArea }}
                        margin="normal"
                        fullWidth
                        error={error.equipmentCodeText.length > 0}
                        helperText={error.equipmentCodeText}
                    />
                    <TextField id="eq_EquipmentName"
                        label={t("EquipmentName")}
                        onInput={(e) => SetRowHandler(e.target.value, "name", row)}
                        defaultValue={row != null ? row.name : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        error={error.equipmentNameText.length > 0}
                        helperText={error.equipmentNameText}
                    />
                    <Autocomplete id="eq_CostCenter"
                        defaultValue={row != null ? row.costCenterCode : ""}
                        onChange={(event, newValue) => {
                            NewCostCenterID(newValue);
                        }}
                        options={costCenterList.map((option) => option.code)}
                        renderInput={(params) => <TextField {...params} margin="normal" label={t("CostCenter")} variant="outlined" error={error.costCenterText.length > 0}  helperText={error.costCenterText} />}
                        fullWidth
                    />
                    <Autocomplete id="eq_EquipmentType"
                        defaultValue={row != null ? row.typeCode : ""}
                        onChange={(event, newValue) => {
                            NewEquipmentTypeID(newValue);
                        }}
                        options={equipmentTypeList.map((option) => option.code)}
                        renderInput={(params) => <TextField {...params} margin="normal" label={t("EquipmentType")} variant="outlined" error={error.equipmentTypeText.length > 0}  helperText={error.equipmentTypeText} />}
                        fullWidth
                    />
                    <Autocomplete id="eq_Area"
                        defaultValue={row != null ? row.areaCode : ""}
                        onChange={(event, newValue) => {
                            NewAreaID(newValue);
                        }}
                        options={areaList.map((option) => option.code)}
                        renderInput={(params) => <TextField {...params} margin="normal" label={t("Area")} variant="outlined" error={error.areaGroupText.length > 0} helperText={error.areaGroupText} />}
                        fullWidth
                    />
                    <TextField id="eq_EquipmentBrand"
                        label={t("EquipmentBrand")}
                        onInput={(e) => SetRowHandler(e.target.value, "brand", row)}
                        defaultValue={row != null ? row.brand : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                    />
                    <TextField id="eq_EquipmentModel"
                        label={t("EquipmentModel")}
                        onInput={(e) => SetRowHandler(e.target.value, "model", row)}
                        defaultValue={row != null ? row.model : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                    />
                    <TextField id="eq_EquipmentWarrantyStart"
                        label={t("EquipmentWarrantyStart")}
                        onInput={(e) => SetRowHandler(e.target.value, "warrantyStart", row)}
                        type="date"
                        defaultValue={row != null ? (row.warrantyStart != null ? row.warrantyStart.substring(0, 10) : null) : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField id="eq_EquipmentWarrantyEnd"
                        label={t("EquipmentWarrantyEnd")}
                        onInput={(e) => SetRowHandler(e.target.value, "warrantyEnd", row)}
                        type="date"
                        defaultValue={row != null ? (row.warrantyEnd != null ? row.warrantyEnd.substring(0, 10) : null) : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField id="eq_EquipmentSAPCode"
                        label={t("EquipmentSAPCode")}
                        onInput={(e) => SetRowHandler(e.target.value, "sapCode", row)}
                        defaultValue={row != null ? row.sapCode : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                    />
                    <TextField id="eq_MesCode"
                        label={t("MesCode")}
                        onInput={(e) => SetRowHandler(e.target.value, "mesCode", row)}
                        defaultValue={row != null ? row.mesCode : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                    />
                    <FormControl margin="normal" fullWidth variant="outlined">
                        <InputLabel>{t("Priority")}</InputLabel>
                        <Select id="eq_Priority" label={t("Priority")} onChange={(e) => SetRowHandler(e.target.value, "priority", row)} defaultValue={row ? row.priority : ""}>
                            <MenuItem id="eq_Priority_Value1" value={1}>{1}</MenuItem>
                            <MenuItem id="eq_Priority_Value2" value={2}>{2}</MenuItem>
                            <MenuItem id="eq_Priority_Value3" value={3}>{3}</MenuItem>
                            <MenuItem id="eq_Priority_Value4" value={4}>{4}</MenuItem>
                            <MenuItem id="eq_Priority_Value5" value={5}>{5}</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField id="eq_EquipmentBarcodeContent"
                        label={t("EquipmentBarcodeContent")}
                        onInput={(e) => SetRowHandler(e.target.value, "barcodeContent", row)}
                        defaultValue={row != null ? row.barcodeContent : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        error={error.barcodeContentText.length > 0}
                        helperText={error.barcodeContentText}
                    />
                    <TextField  id="eq_Plant"
                        label={t("Plant")}
                        value={plantList.map((option) => option.code)}
                        onChange={(event, newValue) => {
                            NewPlantID(newValue);
                        }}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                    ></TextField>
                    <TextField id="eq_FreeText1"
                        label={t("FreeText") + " 1"}
                        onInput={(e) => SetRowHandler(e.target.value, "freeText1", row)}
                        defaultValue={row != null ? row.freeText1 : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                    />
                    <TextField id="eq_FreeText2"
                        label={t("FreeText") + " 2"}
                        onInput={(e) => SetRowHandler(e.target.value, "freeText2", row)}
                        defaultValue={row != null ? row.freeText2 : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                    />
                    <TextField id="eq_FreeText3"
                        label={t("FreeText") + " 3"}
                        onInput={(e) => SetRowHandler(e.target.value, "freeText3", row)}
                        defaultValue={row != null ? row.freeText3 : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                    />
                    <TextField id="eq_FreeText4"
                        label={t("FreeText") + " 4"}
                        onInput={(e) => SetRowHandler(e.target.value, "freeText4", row)}
                        defaultValue={row != null ? row.freeText4 : ""}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        style={{ marginBottom: 20 }}
                    />
                    <Button id="eq_TurnBackButton" onClick={TurnBack} variant="contained" endIcon={<BackIcon />} style={{ marginRight: 20 }}>
                        {t("TurnBack")}
                    </Button>
                    <Button id="eq_SaveButton" onClick={() => UpdateAddHandler(row)} variant="contained" color="primary" disabled={isButtonDisable} endIcon={<CheckIcon />}>
                        {t("Save")}
                    </Button>
                </Grid>
            ) : null}
            <LoadingBackdrop />
        </Container>
    );
}
